import { hotspotFeature, hotspotSmalls, miniItems } from '@/mocks/homeData';

export default function HotspotGrid() {
  return (
    <section id="hot" className="w-full bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-7xl">
        <div className="flex flex-col gap-4 border-b border-background-200 pb-8 md:flex-row md:items-end md:justify-between">
          <div data-reveal>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-medium text-primary-700 md:text-sm">
              <i className="ri-fire-line" />
              今日吃瓜热点
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              大小卡混排，先看主干再看细节
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              主推方向用大卡铺开，细节线索用卡片补齐。不用逐条点开，扫一眼就知道今天该往哪个方向追。
            </p>
          </div>
          <a
            href="#onsite"
            data-reveal
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 cursor-pointer"
          >
            去现场核对
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-3 lg:grid-rows-2">
          <article
            data-reveal
            className="group relative overflow-hidden rounded-lg lg:col-span-2 lg:row-span-2"
          >
            <div className="absolute inset-0 bg-foreground-950" />
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20editorial%20scene%20of%20backstage%20corridor%20with%20warm%20amber%20light%20and%20crimson%20velvet%20curtain%20shadows%2C%20cinematic%20still%20life%2C%20grainy%20film%20texture%2C%20mysterious%20mood%2C%20no%20people&width=1200&height=900&seq=heliao51-hot-feature-02&orientation=landscape"
              alt="黑料51 本周吃瓜热点主推"
              title="黑料51吃瓜热点 本周主推"
              className="absolute inset-0 h-full w-full min-h-[320px] object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-black/10" />
            <div className="relative flex h-full min-h-[320px] flex-col justify-end p-6 md:min-h-[520px] md:p-10">
              <div className="flex flex-wrap items-center gap-3">
                <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950 md:text-sm">
                  {hotspotFeature.tag}
                </span>
                <span className="flex items-center gap-1.5 text-xs text-background-100 md:text-sm">
                  <i className="ri-time-line" />
                  {hotspotFeature.time}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
                {hotspotFeature.title}
              </h3>
              <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
                {hotspotFeature.excerpt}
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-5 text-xs text-background-200 md:text-sm">
                <span className="flex items-center gap-1.5">
                  <i className="ri-eye-line" />
                  {hotspotFeature.heat}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-file-list-3-line" />
                  含 6 条可对照线索
                </span>
              </div>
            </div>
          </article>

          {hotspotSmalls.map((item) => (
            <article
              key={item.id}
              data-reveal
              data-reveal-delay="120"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-40 w-full overflow-hidden bg-background-200 md:h-44">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} 黑料51`}
                  className="h-full w-full object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center justify-between">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="mt-4 font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{item.excerpt}</p>
                <span className="mt-5 flex items-center gap-1.5 text-xs text-primary-700">
                  <i className="ri-pulse-line" />
                  热度 {item.heat}
                </span>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {miniItems.map((item) => (
            <a
              key={item.id}
              href="#onsite"
              data-reveal
              className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 px-4 py-4 transition-colors hover:border-accent-300 hover:bg-accent-50 cursor-pointer"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${item.icon} text-xl`} />
              </span>
              <span className="flex min-w-0 flex-col">
                <span className="truncate font-label text-sm font-medium text-foreground-900 md:text-base">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded-full bg-background-200 px-2 py-0.5">{item.tag}</span>
                  {item.count}
                </span>
              </span>
              <span className="ml-auto flex h-6 w-6 shrink-0 items-center justify-center text-foreground-400">
                <i className="ri-arrow-right-s-line text-lg" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}